import { PageViewEventLogger } from '@repo/tracking-service';

import { CollectErrorBoundary } from '@/components/tax-refund/collect/in-progress/CollectErrorBoundary';
import { PersonalDeductionContainer } from '@/components/tax-refund/collect/in-progress/PersonalDeductionContainer';

function TaxRefundCollectingPage() {
  return (
    <CollectErrorBoundary>
      <PageViewEventLogger pageName={'personal-deduction-loading'} />
      <PersonalDeductionContainer />
    </CollectErrorBoundary>
  );
}

export default TaxRefundCollectingPage;
